<template>
    <div>
        <b-modal size="xl" button-size="sm" ref="finder" hide-footer :id="id" :title="title">
            <EspecificacaoProdutoList :almoxarifado='true' @onDblClickItem="especificacaoProdutoAlmoxarifadoSelect" />
        </b-modal>

        <template v-if="mode === 'finder'">
            <lg-form-input-finder class='p-0' v-model="localObject" @handleClean="handleClean" fieldDescription="descricao"
                :label="label" invalidFeedback="Especificação deve ser informada!" description=""
                :showClear="podeApagar" :disabled="disabled">
                <template #prepend>
                    <b-button @click="show" class="btn-input-finder" pressed v-if="podeMudar" :disabled="disabled">
                        <b-icon icon="search" />
                    </b-button>
                </template>
            </lg-form-input-finder>
        </template>

        <template v-else-if="mode === 'button'">
            <b-button @click="show" variant="success" style="height: 30px" pill size="sm" :disabled="disabled">
                <b-icon icon="plus" /> {{ label }}
            </b-button>
        </template>
    </div>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import EspecificacaoProdutoList from "@/modules/cadastros/especificacao-produto/EspecificacaoProdutoList.vue"

export default {
    name: "LgFinderPageEspecificacaoProdutoAlmoxarifado",
    components: { LgFormInputFinder, EspecificacaoProdutoList },
    props: {
        id: String,
        value: Object,
        label: {
            type: String,
            default: '',
        },
        mode: {
            type: String,
            default: 'finder',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        podeMudar: {
            type: Boolean,
            default: true,
        },
        podeApagar: {
            type: Boolean,
            default: true,
        },
        prefix: {
            type: [String, Array],
            default: '',
        },
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, "Especificação Produto Almoxarifado"].filter(item => item && item != "")
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
    },
    data() {
        return {
            localObject: this.value,
        }
    },
    watch: {
        value(newValue) {
            this.localObject = newValue
        },
        localObject(newValue) {
            this.$emit("input", newValue)
        }
    },
    methods: {
        async show() {
            this.$bvModal.show(this.id)
        },
        async especificacaoProdutoAlmoxarifadoSelect(item) {
            this.localObject = item
            this.$bvModal.hide(this.id)
        },
        handleClean() {
            this.localObject = null
        }
    },
}
</script>